import React from 'react'
import '../../Styles/genelife.css';
import APP_ENV from "../../Environment";

export class Header extends React.Component {

  constructor(props) {
   super(props);
   this.state = {
     isToggleOn: true,
     isToggleOn2: true,
     isToggleOn3: true,
     isToggleOn4: true,
     isToggleOn5: true,
     authState: props.authState
   };

   this.handleClick = this.handleClick.bind(this);
   this.handleClick2 = this.handleClick2.bind(this);
   this.handleClick3 = this.handleClick3.bind(this);
   this.handleClick4 = this.handleClick4.bind(this);
   this.handleClick5 = this.handleClick5.bind(this);
 }

 handleClick() {
   this.setState(function(prevState) {
     return {isToggleOn: !prevState.isToggleOn};
   });
 }
 handleClick2() {
   this.setState(function(prevState) {
     return {isToggleOn2: !prevState.isToggleOn2};
   });
 }
 handleClick3() {
   this.setState(function(prevState) {
     return {isToggleOn3: !prevState.isToggleOn3};
   });
 }
 handleClick4() {
   this.setState(function(prevState) {
     return {isToggleOn4: !prevState.isToggleOn4};
   });
 }
 handleClick5() {
   this.setState(function(prevState) {
     return {isToggleOn5: !prevState.isToggleOn5};
   });
 }

    render() {
        const auth_component = (this.state.authState === "signedIn" || this.state.authState === "ChangeUserInfo") ?
            <a href={APP_ENV.FRONT_URL + "/logout"} className="login">ログアウト</a> :
            <a href={APP_ENV.FRONT_URL + "/"} className="login">ログイン</a>;

        return (

        <header>
        <div className="header_wrapper">
          <div className="gl_header">
            <div className="gl_header_inner">
              <div className="site_logo">
                <a href="https://www.genelife.jp/"><img src={require("../../images/brand/site_logo.png")} alt="GeneLife 遺伝子検査のジーンライフ"/></a>
              </div>
              <nav className="gl_header_pc">
                <ul className="gl_header_nav">
                  <li><a href='https://www.genelife.jp/'>トップページ</a></li>
            
                  <li><a href="https://genelife.jp/guideline/top.html">ご利用ガイド</a></li>
                  <li><a href="https://genelife.jp/faq/index.html">FAQ</a></li>
         
                  <li className={this.state.isToggleOn2 ? 'toggle' : 'toggle active'}>
                    <span className="toggle_trg" onClick={this.handleClick2}>お問合わせ</span>
                    <div className={this.state.isToggleOn2 ? 'gl_header_nav_sub' : 'gl_header_nav_sub active'}>
                      <div className="gl_header_nav_sub_inner_s">
                      <ul className="sublist">
                        <li><a href="https://genelife.jp/contact/input">お問合わせ（個人向け）</a></li>
                        <li><a href="https://genelife.jp/contactbz/input">お問合わせ（法人向け）</a></li>
                      </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </nav>
              <nav className="gl_header_pc">
                <ul className="gl_header_nav_auth">
                  <li><a href={APP_ENV.ECCMYPAGE} className="mypage">マイページ</a></li>
                    <li>{auth_component}</li>
                  <li><a href="https://sales.genelife.jp/order/cart" className="cart">カート</a></li>
                </ul>
              </nav>
            </div>
          </div>
            <div className={this.state.isToggleOn3 ? 'gl_header_sp' : 'gl_header_sp active'}>
        <div className="gl_header_sp_in">

            <ul className="gl_header_nav sp_navi_top">
            <li><a href='https://www.genelife.jp/'>トップページ</a></li>
              <li><a href="https://genelife.jp/guideline/top.html">ご利用ガイド</a></li>
              <li><a href="https://genelife.jp/faq/index.html">FAQ・</a></li>
         
              <li className={this.state.isToggleOn5 ? 'toggle' : 'toggle active'}>
                <span  onClick={this.handleClick5} className={this.state.isToggleOn5 ? 'toggle_trg_s' : 'toggle_trg_s active'}>お問合わせ</span>
                <div className={this.state.isToggleOn5 ? 'gl_header_nav_sub' : 'gl_header_nav_sub active'}>
                  <div className="gl_header_nav_sub_inner_s">
                  <ul className="sublist">
                  <li><a href="https://genelife.jp/contact/input">お問合わせ（個人向け）</a></li>
                  <li><a href="https://genelife.jp/contactbz/input">お問合わせ（法人向け）</a></li>
                  </ul>
                  </div>
                </div>
              </li>
            </ul>


            <nav className="gl_header_nav sp_navi_auth">
              <ul className="gl_header_nav_auth">
                <li><a href={APP_ENV.ECCMYPAGE} className="mypage">マイページ</a></li>
                  <li>{auth_component}</li>
                <li><a href="https://sales.genelife.jp/order/cart" className="cart">カート</a></li>
              </ul>
            </nav>

         

        </div>
        </div>
          <div className="spnavi_bg"></div>
          <div className="sp_login_onhead">{auth_component}</div>
            <button type="button"  onClick={this.handleClick3} className={this.state.isToggleOn3 ? 'menu-trigger' : 'menu-trigger active'}>
            <span></span>
            <span></span>
            <span></span>
            </button>
        </div>


        </header>




        )
    }
}

export default Header;
